
export class ZipperDto {
    id: number;
    style?: string;
    size?: string;
    consumption?: string;
    createdUser?: string;
    isActive?:boolean
    versionFlag?: number;
    updatedUser?:string;
    updatedAt?:string;
    
    constructor(id: number, style?: string,size?: string,consumption?: string,
     createdUser?:string,isActive?:boolean,versionFlag?: number,updatedUser?:string,
     updatedAt?:string) {
      this.id = id;
      this.style = style;
      this.size = size;
      this.consumption= consumption
      this.createdUser = createdUser;
      this.isActive = isActive;
      this.versionFlag = versionFlag;
      this.updatedUser = updatedUser;
      this.updatedAt = updatedAt;

    }
  }
  